export default __webpack_public_path__ + "static/media/pc3.f8acd0d6.jpg";